//EXTERNAL
import { useParams } from "react-router-dom";
//COMPONENTS
import * as ComponentLibrary from "@picnicmedia/masanatemples123";
//HOOKS
import is_new_creative from "../../../../hooks/is_new_creative";
//LIBS
import { analytics_record } from "../../../../libs/amplify";
import { save_file_locally } from "../../../../libs/file_saver";
import { logger } from "../../../../libs/logger";
import { merge_images } from "../../../../libs/merge_images";
import { Google_Analytics_Event } from "../../../../libs/google-analytics";
//CONTEXT
import { useCreativeState } from "../../../../contexts/creative.context";
import { useNotificationDispatch } from "../../../../contexts/notification.context";
import { useUserState } from "../../../../contexts/user.context";
//CONFIGS
import config from "../../../../configs/config";
import studio_config from "../../../../configs/studio.json";
//TYPES
import { StudioConfig } from "../types";
//ASSETS
import exportPNGContainerStory from "../../../../assets/export-as-png-container-story.png";
import exportPNGContainerPost from "../../../../assets/export-as-png-container-post.png";
//FUNCTIONS
import { getDomScreenshot } from "./getDomScreenshot";

export function ExportPngButton() {
  const { creativeId } = useParams<Record<string, string | undefined>>();
  const user = useUserState();
  const creative = useCreativeState();
  const notificationDispatch = useNotificationDispatch();
  const studioConfig: StudioConfig = studio_config;
  const isNewCreative = is_new_creative();

  const handleExportPng = async (e: any) => {
    Google_Analytics_Event({ name: "creative_export", category: "ad_creative", action: "export", label: creativeId });
    e.currentTarget.blur();
    if (config.analytics.DISABLED === false && user.teamId !== "pi6j") {
      analytics_record({
        name: "exportPng",
        attributes: {
          eventType: "click",
          userId: `${user.id}`,
          userEmail: `${user.email}`,
          teamId: `${user.teamId}`,
          teamName: `${user.teamName}`,
          advertiserId: `${creative.advertiserId}`,
          advertiserName: `${creative.advertiserName}`,
          creativeId: `${creativeId}`,
          adName: `${creative.adName}`,
          brandName: `${creative.metadata.brandName}`,
          format: `${creative.metadata.format}`,
          assetType: `${creative.metadata.slides.find((slide: any) => slide.media.mimeType.includes("video")) ? "video" : "image"}`,
        },
      });
    }

    try {
      let imageUrl: string;
      let domScreenshot = await getDomScreenshot(creative);
      imageUrl = URL.createObjectURL(domScreenshot);
      // Works out which container image to use
      let container = studioConfig.formats[creative.metadata.format].exportPng[creative.metadata.aspectRatio].container === "story" ? exportPNGContainerStory : exportPNGContainerPost;
      // Merge created screenshot with phone container image
      let mergedImage = await merge_images([
        { src: container, x: 0, y: 0 },
        {
          src: imageUrl,
          x: studioConfig.formats[creative.metadata.format].exportPng[creative.metadata.aspectRatio].xValue,
          y: studioConfig.formats[creative.metadata.format].exportPng[creative.metadata.aspectRatio].yValue,
        },
      ]);
      save_file_locally(mergedImage, `${creative.adName}-export.png`);
      // remove reference to imageURl
      URL.revokeObjectURL(imageUrl);
      notificationDispatch({
        type: "ADD",
        payload: {
          header: "Creative exported",
          message: "",
          type: "success",
          autoDismiss: true,
        },
      });
    } catch (error) {
      logger({ error, user, context: { origin: "handleExportPng_handleExportPng" } });
      Google_Analytics_Event({ name: "error", category: error.message + " " + error.cause, action: "HandleExportPng_handleExportPng", label: user.email });
      let errorMessage = "";
      if (error instanceof Error) {
        errorMessage = error.message;
      }
      notificationDispatch({
        type: "ADD",
        payload: {
          header: "Error exporting creative",
          message: errorMessage,
          type: "error",
          autoDismiss: false,
        },
      });
    }
  };

  return <ComponentLibrary.PCActionButton isDisabled={isNewCreative} text={"Export PNG"} clickHandler={handleExportPng} iconLeft={"image"} iconColor={"color-text-5"} textColor={"color-text-5"} color={""} />;
}
